module.exports = __webpack_public_path__ + "4a60bf8b16b98b3ecc9717ef2781956a.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
 ** module id = 2210
 ** module chunks = 73
 **/